export const ListQueryKey = 'properties';
export const DetailQueryKey = 'property';

export const Urls = {
  selectUrl: '/property/list',
  updateUrl: '/property/update',
  deleteUrl: '/property/delete',
  createUrl: '/property/create',
  detailUrl: '/property/detail',
};
